import React, {useState} from "react";
import {observer} from "mobx-react";
import './modal.scss'
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import {InfoIcon} from "../../assets/svg-icons/InfoIcon";
import {Checkbox} from "@mui/material";
import ConditionalComponent from "../Shared/ConditionalComponent";

const ConfirmChangeDefaultLanguage = observer(() => {
    const {modalStore, generalStore} = useStores();
    const [copyOld, setCopyOld] = useState(false);

    const {currentLanguage, newLanguage, isChangeDefault} = modalStore.modalData;

    function closeModal() {
        setCopyOld(false);
        modalStore.isConfirmChangeDefaultLanguageOpen = false;
    }

    const  confirmChangeDefaultLanguage = async () =>{
        await modalStore.modalData.onConfirm(copyOld);
        closeModal();
    }

    const renderBody = () => {
        return (
            <>
                <div className="change-default-language-text">
                    {isChangeDefault
                        ? <span>{generalStore.translate('changeTheDefaultLanguageForThisProcedureFrom')} <strong>{currentLanguage}</strong> {generalStore.translate('to', true)} <strong>{newLanguage}?</strong> </span>
                        : `${generalStore.translate('addNewProcedureLanguage')}: ${newLanguage}?`
                    }
                </div>
                <ConditionalComponent if={!isChangeDefault}>
                    <div className="copy-old-default-checkbox-container">
                        <Checkbox
                            checked={copyOld}
                            className="copy-old-default-checkbox"
                            color="primary"
                            onChange={() => setCopyOld(!copyOld)}
                        />
                        <div className="copy-old-default-checkbox-label">
                            {`${generalStore.translate('copyAllCurrent')} ${currentLanguage} ${generalStore.translate('text', true)}`}
                        </div>
                    </div>
                </ConditionalComponent>
            </>
        )
    }

    function renderTitle() {
        return (
            <div className='attention-title'>
                <InfoIcon/>
                <div>{generalStore.translate(isChangeDefault ? 'confirmChangeDefaultLanguage' : 'confirmAddLanguageOption')}</div>
            </div>
        )
    }

    return (
        <GeneralDialog
            openControl='isConfirmChangeDefaultLanguageOpen'
            className='attention-dialog'
            onEnter={null}
            title={renderTitle()}
            body={renderBody()}
            isConfirmDisabled={false}
            onConfirm={confirmChangeDefaultLanguage}
            confirmText={generalStore.translate('confirm')}
            buttonClass='notification'
            specialOnClose={closeModal}
        />
    );
});

export default ConfirmChangeDefaultLanguage;
